<template>
    <div>
        <Loading :loading="$apollo.queries.dashboardPage.loading" />
        <Navbar :languageList="dashboardPage.languageList" />
        <v-fade-transition>
            <v-container fluid v-show="!($apollo.queries.dashboardPage.loading)">
                <v-layout row wrap >
                    <v-flex xs12 md6>
                        <h1 class="text-xs-center mb-2 display-1 font-weight-light">
                            Add new key
                        </h1>
                        <v-select
                            :items="dashboardPage.dictList"
                            label="Dictionary"
                            v-model="dict"
                            outline
                        ></v-select>
                        <v-textarea
                            outline
                            v-model="value"
                            rows="1"
                            hide-details
                            label="Key"
                            required
                        ></v-textarea>
                        <h1 class="text-xs-center ma-2 display-1 font-weight-light">
                            Translations:
                        </h1>
                        <v-textarea
                            outline
                            rows="1"
                            class="my-2"
                            v-for="lang in dashboardPage.languageList"
                            v-model="translations[lang]"
                            :key="lang"
                            :label="lang"
                            hide-details
                        ></v-textarea>
                        <v-container fluid>
                            <v-layout row justify-space-between >
                                <v-flex shrink>
                                    <v-btn
                                        large
                                        color="primary"
                                        :disabled="!dict || !value"
                                        @click="submitForm"
                                    >Add</v-btn>
                                </v-flex>
                                <v-flex shrink>
                                    <v-btn
                                        large
                                        outline
                                        color="primary"
                                        @click="clearForm"
                                    >Clear</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                    <v-flex xs12 md6>
                        <h1 class="text-xs-center mb-2 display-1 font-weight-light">
                            Newest translations
                        </h1>
                        <v-container
                            fluid
                            v-if="dashboardPage.translations.length > 0"
                        >
                            <v-layout
                                v-for="{lang, keyId, key, value, id} in dashboardPage.translations" :key="id"
                                row
                                align-center
                                wrap>
                                <v-flex xs1>
                                    <h5 class="title font-weight-light">{{ lang }}</h5>
                                </v-flex>
                                <v-flex xs3>
                                    {{ key }}
                                </v-flex>
                                <v-flex grow>
                                    <p v-if="editedTranslationId !== id"> {{ value }} </p>
                                    <v-textarea
                                        v-if="editedTranslationId === id"
                                        outline
                                        rows="1"
                                        class="my-2"
                                        v-model="editedTranslationValue"
                                        :label="translation"
                                        hide-details
                                    ></v-textarea>
                                </v-flex>
                                <v-flex shrink>
                                    <v-btn
                                        v-if="editedTranslationId !== id"
                                        flat
                                        icon
                                        @click="setEditedTranslationId(id, value)"
                                    >
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <v-btn
                                        v-if="editedTranslationId === id"
                                        flat
                                        icon
                                        @click="saveEditedTranslationValue"
                                    >
                                        <v-icon>save</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex shrink>
                                    <v-btn
                                        color="primary"
                                        @click="approveTranslation(lang, keyId, id)"
                                    >Approve</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-fade-transition>
        <v-snackbar
            v-model="showSnackbar"
            bottom
            right
            :timeout="6000"
         >{{ message }}</v-snackbar>
    </div>
</template>

<script>

import Navbar from "@/components/Navbar"
import Loading from "@/components/Loading"
import { DASHBOARD_PAGE, APPROVE_TRANSLATION, EDIT_TRANSLATION, ADD_KEY } from "../graphql"

export default {
    components: {
        Navbar,
        Loading
    },
    apollo: {
        dashboardPage: {
            query: DASHBOARD_PAGE
        }
    },
    data () {
        return {
            dashboardPage: {
                dictList: [],
                languageList: [],
                translations: []
            },
            translations: {},
            editedTranslationId: null,
            editedTranslationValue: "",
            dict: "",
            value: "",
            showSnackbar: false,
            message: ""
        }
    },
    methods: {
        approveTranslation: function (lang, keyId, id) {
            this.$apollo.mutate({
                mutation: APPROVE_TRANSLATION,
                variables: {
                    lang,
                    keyId,
                    translationId: id
                },
                update: function (store, data) {
                    let d = store.readQuery({
                        query: DASHBOARD_PAGE
                    })

                    store.writeQuery({
                        query: DASHBOARD_PAGE,
                        data: {
                            dashboardPage: {
                                translations: d.dashboardPage.translations.filter(t => t.id !== id),
                                __typename: "translations"
                            }
                        }
                    })
                }
            }).catch(error => {
                this.showSnackbar = true
                this.message = error
            })
        },
        setEditedTranslationId: function (id, value) {
            this.editedTranslationId = id
            this.editedTranslationValue = value
        },
        saveEditedTranslationValue: function () {
            const translationId = this.editedTranslationId
            const value = this.editedTranslationValue
            this.$apollo.mutate({
                mutation: EDIT_TRANSLATION,
                variables: {
                    value,
                    translationId
                },
                update: function (store, data) {
                    let d = store.readQuery({
                        query: DASHBOARD_PAGE
                    })

                    store.writeQuery({
                        query: DASHBOARD_PAGE,
                        data: {
                            dashboardPage: {
                                translations: d.dashboardPage.translations.map(t => t.id === translationId ? Object.assign({}, t, { value }) : t),
                                __typename: "translations"
                            }
                        }
                    })
                }
            }).then(data => {
                this.editedTranslationId = null
                this.editedTranslationValue = ""
                this.message = "Saved successfully"
            }).catch(error => {
                this.showSnackbar = true
                this.message = error
            })
        },
        submitForm: function () {
            const formData = {
                dict: this.dict,
                value: this.value,
                translations: this.translations
            }
            this.$apollo.mutate({
                mutation: ADD_KEY,
                variables: {
                    dict: this.dict,
                    value: this.value,
                    translations: JSON.stringify(this.translations)
                }
            }).then(data => {
                this.clearForm()
                this.showSnackbar = true
                this.message = "New key has been added successfully"
            }).catch(error => {
                this.showSnackbar = true
                this.message = error
                this.data = Object.assign({}, this.data, formData)
            })
        },
        clearForm: function () {
            this.value = ""
            this.translations = {}
        }
    }
}

</script>
